export interface GameSettings {
	mineCount: number;
	x: number;
	y: number;
}
export const BeginnerMode: GameSettings = {
	x: 9, y: 9, mineCount: 10
};
export const HobbyistMode: GameSettings = {
	x: 16, y: 16, mineCount: 40
};
export const ProMode: GameSettings = {
	x: 30, y: 16, mineCount: 99
};